import React, {useEffect} from "react"
import { Card, CardBody, Row, Col, CardTitle } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import { lastSevenDays } from "helpers/helpers"

function BarChart(props) {
  const {data} = props

  const series = [
    {
      name: "Deposits",
      data: data.deposit,
    },
    {
      name: "Withdrawals",
      data: data.withdraw,
    },
  ]
  const options = {
    chart: {
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "45%",
        endingShape: "rounded",
      },
    },
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },

    colors: ["#34c38f", "#f46a6a"],
    xaxis: {
      categories: data.day??[],
    },
    yaxis: {
      title: {
        text: "",
      },
    },
    grid: {
      borderColor: "#f1f1f1",
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      y: {
        formatter: function (val) {
          return val
        },
      },
    },
  }

  return (
      <Row>
        <Col lg={12}>
          <Card>
            <CardBody>
              <CardTitle className="mb-4">Column with Data Labels </CardTitle>
              <ReactApexChart
                  options={options}
                  series={series}
                  type="bar"
                  height={350}
              />
            </CardBody>
          </Card>
        </Col>
      </Row>
  )
}

export default BarChart
